export class MarketingCloudForms {
  /**
   * Marketing Cloud Forms
   * Check if in Sitecore Editor mode before running anything
   * Find cookie with specific name, loop through the keys and get the values
   * Find those matching keys on the hidden inputs using their values and replace the value with the cookie value
   * If the parameter is missing use empty string
   * Some debugging help as well, just add debug=true to query string
   */
  /* eslint-disable-next-line */
  constructor(formSelector) {
    this.debug = this.getQueryString('debug');
    if (this.debug) {
      console.log(
        '%cMarketingCloudForms 4',
        'background: #aaa; color: #fff; padding: 10px 20px;margin-top:20px;',
      );
    }
    this.form = '.DeManager';
    this.cookieName = 'gtm_utm';
    this.localStorageKey = 'rd_sec';
    this.gtmCookieName = 'gtm_ga_session_id';
    this.cidCookieName = 'gtm_cid';
    this.lidCookieName = 'gtm_lid';

    // If in editor mode this script would run and break things
    this.isEditorMode = document.body.classList.contains('pagemode-edit');
    if (!this.isEditorMode) {
      this.init();
    }
  }

  readUTMFromQueryString(utmParams) {
    if (this.getQueryParametersCount() === 0) {
      if (this.debug) {
        console.log(
          '%cquery params count: 0',
          'background: #aaa; color: #fff; padding: 10px 20px;margin-left:40px;',
        );
      }
      return {};
    }
    let paramNames = [
      'utm_campaign',
      'utm_content',
      'utm_medium',
      'utm_source',
      'utm_id',
      'utm_ga_id',
    ];
    paramNames.forEach((name) => {
      var paramVal = this.getQueryString(name);
      if (this.debug) {
        console.log(
          '%cquery param ' + name + ' value: ' + paramVal,
          'background: #aaa; color: #fff; padding: 10px 20px;margin-left:40px;',
        );
      }
      if (paramVal) {
        utmParams[name] = paramVal || '';
      }
    });

    return utmParams;
  }

  readUTMFromCookie() {
    if (this.debug) {
      console.log(
        '%creadUTMFromCookie',
        'background: #aaa; color: #fff; padding: 10px 20px;margin-left:20px;',
      );
      console.log(
        '%ccookieName: ' + this.cookieName,
        'background: #aaa; color: #fff; padding: 10px 20px;margin-left:40px;',
      );
    }
    let cookieValue = document.cookie
      .split('; ')
      .find((row) => row.startsWith(`${this.cookieName}=`));
    if (this.debug) {
      console.log(
        '%ccookieValue: ' + cookieValue,
        'background: #aaa; color: #fff; padding: 10px 20px;margin-left:40px;',
      );
    }
    let utmParams = {};

    if (cookieValue) {
      if (this.debug) {
        console.log(
          '%cFound cookieValue',
          'background: #00C176; color: #fff; padding: 10px 20px;margin-left:60px;',
        );
      }
      let utmParamsString = cookieValue.substring(`${this.cookieName}=`.length);
      if (this.debug) {
        console.log(
          '%cutmParamsString: ' + utmParamsString,
          'background: #aaa; color: #fff; padding: 10px 20px;margin-left:60px;',
        );
      }
      utmParamsString.split('&').forEach((param) => {
        if (this.debug) {
          console.log(
            '%cValue: ' + param,
            'background: #aaa; color: #fff; padding: 10px 20px;margin-left:80px;',
          );
        }
        let [key, value] = param.split('=');
        if (key.startsWith('utm_')) {
          utmParams[key] = value || ''; // Set an empty string if the value is undefined
        }
      });
    } else {
      if (this.debug) {
        console.log(
          '%cMissing cookieValue for UTM',
          'background: #CC333F; color: #fff; padding: 10px 20px;margin-left:60px;',
        );
      }
    }

    utmParams = this.readUTMFromQueryString(utmParams);

    let gaCookie = document.cookie
      .split('; ')
      .find((row) => row.startsWith(`${this.gtmCookieName}=`));
    if (gaCookie) {
      if (this.debug) {
        console.log(
          '%cFound cookieValue for GTM GA Session',
          'background: #00C176; color: #fff; padding: 10px 20px;margin-left:60px;',
        );
      }
      let gtmParamsString = gaCookie.substring(`${this.gtmCookieName}=`.length);
      if (this.debug) {
        console.log(
          '%cgtmParamString: ' + gtmParamsString,
          'background: #aaa; color: #fff; padding: 10px 20px;margin-left:60px;',
        );
      }

      utmParams['ga_session_id'] = gtmParamsString || '';
    } else {
      if (this.debug) {
        console.log(
          '%cMissing cookieValue for GA Session',
          'background: #CC333F; color: #fff; padding: 10px 20px;margin-left:60px;',
        );
      }
    }

    var paramVal = this.getQueryString('crec');

    if (paramVal) {
      if (this.debug) {
        console.log(
          '%cquery param crec value: ' + paramVal,
          'background: #aaa; color: #fff; padding: 10px 20px;margin-left:40px;',
        );
      }
      utmParams['sfmc_cid'] = paramVal || '';
    } else {
      let cidCookie = document.cookie
        .split('; ')
        .find((row) => row.startsWith(`${this.cidCookieName}=`));

      if (cidCookie) {
        if (this.debug) {
          console.log(
            '%cFound cookieValue for GTM GA CID',
            'background: #00C176; color: #fff; padding: 10px 20px;margin-left:60px;',
          );
        }
        let cidParamsString = cidCookie.substring(`${this.cidCookieName}=`.length);
        if (this.debug) {
          console.log(
            '%ccidParamString: ' + cidParamsString,
            'background: #aaa; color: #fff; padding: 10px 20px;margin-left:60px;',
          );
        }

        utmParams['sfmc_cid'] = cidParamsString || '';
      } else {
        if (this.debug) {
          console.log(
            '%cMissing cookieValue for GA CID',
            'background: #CC333F; color: #fff; padding: 10px 20px;margin-left:60px;',
          );
        }
      }
    }
    /* eslint-disable-next-line */
    var paramVal = this.getQueryString('lrec');

    if (paramVal) {
      if (this.debug) {
        console.log(
          '%cquery param lrec value: ' + paramVal,
          'background: #aaa; color: #fff; padding: 10px 20px;margin-left:40px;',
        );
      }
      utmParams['sfmc_lid'] = paramVal || '';
    } else {
      let lidCookie = document.cookie
        .split('; ')
        .find((row) => row.startsWith(`${this.lidCookieName}=`));
      if (lidCookie) {
        if (this.debug) {
          console.log(
            '%cFound cookieValue for GTM GA LID',
            'background: #00C176; color: #fff; padding: 10px 20px;margin-left:60px;',
          );
        }
        let lidParamsString = lidCookie.substring(`${this.lidCookieName}=`.length);
        if (this.debug) {
          console.log(
            '%clidParamString: ' + lidParamsString,
            'background: #aaa; color: #fff; padding: 10px 20px;margin-left:60px;',
          );
        }

        utmParams['sfmc_lid'] = lidParamsString || '';
      } else {
        if (this.debug) {
          console.log(
            '%cMissing cookieValue for GA LID',
            'background: #CC333F; color: #fff; padding: 10px 20px;margin-left:60px;',
          );
        }
      }
    }

    return utmParams;
  }

  readRDSecFromLocalStorage() {
    if (this.debug) {
      console.log(
        '%creadRDSecFromLocalStorage',
        'background: #aaa; color: #fff; padding: 10px 20px;margin-left:20px;',
      );
      console.log(
        '%clocalStorageKey: ' + this.localStorageKey,
        'background: #aaa; color: #fff; padding: 10px 20px;margin-left:40px;',
      );
    }
    let rdSecValue = localStorage.getItem(this.localStorageKey);
    if (rdSecValue) {
      if (this.debug) {
        console.log(
          '%cFound rdSecValue',
          'background: #00C176; color: #fff; padding: 10px 20px;margin-left:60px;',
        );
        console.log(
          '%cValue: ' + rdSecValue,
          'background: #aaa; color: #fff; padding: 10px 20px;margin-left:80px;',
        );
      }
      return rdSecValue || '';
    } else {
      if (this.debug) {
        console.log(
          '%cMissing rdSecValue',
          'background: #CC333F; color: #fff; padding: 10px 20px;margin-left:60px;',
        );
      }
    }
    return '';
  }

  updateFormFields() {
    if (this.debug) {
      console.log(
        '%cupdateFormFields',
        'background: #aaa; color: #fff; padding: 10px 20px;margin-left:20px;',
      );
      console.log(
        '%cForm: ' + this.form,
        'background: #aaa; color: #fff; padding: 10px 20px;margin-left:40px;',
      );
    }

    let utmParams = this.readUTMFromCookie();
    let rdSecValue = this.readRDSecFromLocalStorage();
    let form = document.querySelector(this.form);

    if (form) {
      if (this.debug) {
        console.log(
          '%cFound form',
          'background: #00C176; color: #fff; padding: 10px 20px;margin-left:40px;',
        );
        console.log(utmParams);
      }
      let hiddenFields = form.querySelectorAll('input[type="hidden"].js-replace');
      if (this.debug) {
        console.log(
          '%cHidden form fields: ',
          'background: #aaa; color: #fff; padding: 10px 20px;margin-left:40px;',
        );
      }
      hiddenFields.forEach((field) => {
        if (this.debug) {
          console.log(field);
        }
        let fieldName = field.value;
        if (fieldName === 'rd_sec') {
          field.value = rdSecValue;
          /* eslint-disable-next-line */
        } else if (fieldName && utmParams.hasOwnProperty(fieldName)) {
          field.value = utmParams[fieldName];
        } else {
          field.value = ''; // Replace with empty string if UTM parameter not found
        }
      });
    }
  }

  init() {
    this.updateFormFields();
    let form = document.querySelector(this.form);
    if (form) {
      let submitButton = form.querySelector('input[type="submit"]');
      submitButton.addEventListener('click', this.handleSubmit);
      let params = {};
      params.event = 'sfmc.shown';
      params.action = 'form shown';
      if (form.querySelector('[data-sc-field-name="form_type"]')) {
        params.formType = form.querySelector('[data-sc-field-name="form_type"]').value;
      }

      if (form.querySelector('[data-sc-field-name="form_type_content"]')) {
        params.formTypeContent = form.querySelector(
          '[data-sc-field-name="form_type_content"]',
        ).value;
      }

      if (form.querySelector('[name$="FormItemId"]')) {
        params.formId = form.querySelector('[name$="FormItemId"]').value;
      }

      params.fieldsNo = form.querySelectorAll('input:not([type="hidden"],[type="submit"])').length;
      // call datalayer

      this.sendToDataLayer(params);

      // check if it's at least 25% visible
      var rect = form.getBoundingClientRect();
      if (
        rect.top + rect.height / 4 > 0 && // top
        rect.left + rect.width / 4 > 0 && // left
        rect.top + rect.height / 4 <
          (window.innerHeight || document.documentElement.clientHeight) && // bottom
        rect.left + rect.width / 4 < (window.innerWidth || document.documentElement.clientWidth) // right
      ) {
        params.event = 'sfmc.impression';
        params.action = 'form impression';
        this.sendToDataLayer(params);
      } else {
        // IntersectionObserver options: 25% visibility threshold
        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              // entry.intersectionRatio is fraction of element visible (0..1)
              if (entry.isIntersecting && entry.intersectionRatio >= 0.25) {
                const impressionParams = Object.assign({}, params, {
                  event: 'sfmc.impression',
                  action: 'form impression',
                });

                // call the class method to send to dataLayer
                this.sendToDataLayer(impressionParams);
                // If you want this only once, uncomment the next line:
                observer.disconnect();
              }
            });
          },
          { threshold: [0, 0.25, 1] },
        );

        observer.observe(form);
      }
    }
  }

  handleSubmit() {
    let debug = new URLSearchParams(window.location.search).get('debug');
    if (debug) {
      console.log('Form submit handler!');
    }

    let form = document.querySelector('.DeManager');
    $('.DeManager').valid(); // force form validation
    let params = {};
    if (form.querySelector('[data-sc-field-name="form_type"]')) {
      params.formType = form.querySelector('[data-sc-field-name="form_type"]').value;
    }

    if (form.querySelector('[data-sc-field-name="form_type_content"]')) {
      params.formTypeContent = form.querySelector('[data-sc-field-name="form_type_content"]').value;
    }

    if (form.querySelector('[data-sc-field-name="marketing_consent"]')) {
      let val = form.querySelector('[data-sc-field-name="marketing_consent"]').checked;
      params.consent = val === true ? '1' : '0';
    }

    if (form.querySelector('[name$="FormItemId"]')) {
      params.formId = form.querySelector('[name$="FormItemId"]').value;
    }

    if (form.querySelector('[type="Email"]')) {
      params.email = form.querySelector('[type="Email"]').value;
    }

    params.fieldsNo = form.querySelectorAll('input:not([type="hidden"],[type="submit"])').length;
    if (form.querySelectorAll('.field-validation-error').length == 0) {
      if (debug) {
        console.log('Form is valid');
      }

      params.event = 'sfmc.submit';
      params.action = 'form submitted';

      //send to data layer
    } else {
      params.event = 'sfmc.error';
      params.action = 'form error';
    }

    window.dataLayer = window.dataLayer || [];
    let dlObj = {
      event: params.event,
      form: {
        action: params.action,
        type: params.formType,
        'type content': params.formTypeContent,
        url: window.location.href,
        provider: 'sfmc',
        email: params.email,
        consent: params.consent,
        fields: params.fieldsNo,
        id: params.formId,
      },
    };
    if (debug) {
      console.log('Sending to dataLayer:');
      console.log(dlObj);
    }
    window.dataLayer.push(dlObj);
  }

  sendToDataLayer(params) {
    window.dataLayer = window.dataLayer || [];
    let dlObj = {
      event: params.event,
      form: {
        action: params.action,
        type: params.formType,
        'type content': params.formTypeContent,
        url: window.location.href,
        consent: params.consent,
        provider: 'sfmc',
        fields: params.fieldsNo,
        id: params.formId,
      },
    };
    if (this.debug) {
      console.log('Sending to dataLayer:');
      console.log(dlObj);
    }
    window.dataLayer.push(dlObj);
  }

  getQueryString(parameter) {
    let urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(parameter);
  }

  getQueryParametersCount() {
    let params = new URLSearchParams(window.location.search);
    return params.size;
  }
}
